import React, { useRef, useState, useEffect } from "react";
import TextInput from "../../Components/TextInput/InputText";
import styles from "./AddContacts.module.css";
import { emailValidate } from "../../Values/validatorsnew";
import { connect, useDispatch } from "react-redux";
import "../../theme-vars.css";
import { Box, Grid, useMediaQuery, useTheme } from "@mui/material";
import DropDownText from "../../Components/DropDownText/DropDownText";
import StyledSubmitButton from "../../Components/Buttons/StyledSubmitButton";
import { Circles } from "react-loader-spinner";
import PhoneNumberWrapper from "../../Components/TextInput/PhoneNumberWrapper";
import { contactResources, createContacts, fetchConstants, fetchNewPropertySubType, fetchpropertySubType, fetchpropertyType } from "../../Services/contacts";
import Loading from "../../Components/Loading/Loading";
import { AiOutlineClose } from "react-icons/ai";
import { showSnackbarAction } from "../../Redux/actions";
import { country_code, url } from "../../Values/constants";
import { themeColors } from "../../Components/theme";
import axios from "axios";
import PhoneInput, { CountryData } from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { styled } from "@mui/material/styles";
import { TextField } from "@mui/material";


const primaryColor = "#292744";
// 🔹 Custom styled TextField
const CustomTextArea = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    borderRadius: 12,
    backgroundColor: "#f7f8fa",
    fontSize: "var(--font-size-large)",
    fontFamily: "var(--font-family-main)",
    "& fieldset": {
      borderColor: "#bfc7d5",
    },
    "&:hover fieldset": {
      borderColor: primaryColor,
      border: `1.5px solid ${primaryColor}`
    },
    "&.Mui-focused fieldset": {
      borderColor: primaryColor,
      border: `1.5px solid ${primaryColor}`
    },
  },
  "& .MuiInputBase-input": {
    padding: "14px",
    fontSize: 16,
    color: "#222",
  },
  "& .MuiInputLabel-root": {
    fontWeight: 500,
    fontSize: 15,
    color: primaryColor,
  },
});

const AddContacts = ({
  history,
  user,
  organizationUsers,
  role,
  theme,
  conatctHeader,
  authToken,
  organizationData,
}: {
  history: any;
  user: any;
  organizationUsers: any;
  role: string;
  theme: any;
  conatctHeader: any;
  authToken: any;
  organizationData: any;
}) => {
  const themeMUI = useTheme();
  const isMobile = useMediaQuery(themeMUI.breakpoints.down("sm"));
  const dispatcher = useDispatch();
  const firstNameRef: any = useRef();
  const lastNameRef: any = useRef();
  const emaileRef: any = useRef();
  const [load, setLoad] = useState(false);
  const [countryCodeList, setCountryCodeList] = useState<string[]>([]);
  const [phoneCountryCode, setPhoneCountryCode] = useState('in');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [finalPhoneNumber, setFinalPhoneNumber] = useState('');
  const [alternatePhoneCountryCode, setAlternatePhoneCountryCode] = useState('in');
  const [alternatePhoneNumber, setAlternatePhoneNumber] = useState('');
  const [finalAlternatePhoneNumber, setFinalAlternatePhoneNumber] = useState('');
  const [countryCode, setCountryCode] = useState<string>("");
  const [note, setNote] = useState("");
  const noteRef: any = useRef();
  const [projectSelected, setProjectSelected] = useState<any>({ label: "Select", value: "Select" });
  const [locationSelected, setlocationSelected] = useState<any>({ label: "Select", value: "Select" });
  const [budgetSelected, setBudgetSelected] = useState<any>({ label: "Select", value: "Select" });
  const [propertyTypeSelected, setPropertyTypeSelected] = useState<any>({ label: "Select", value: "Select" });
  const [leadTypeSelected, setLeadTypeSelected] = useState<any>({ label: "Select", value: "Select" });
  const [propertyStageSelected, setPropertyStageSelected] = useState<any>({ label: "Select", value: "Select" });
  const [propertySubTypeSelected, setPropertySubTypeSelected] = useState<any>({ label: "Select", value: "Select" });
  const [leadSourceSelected, setLeadSourceSelected] = useState<any>({ label: "Select", value: "Select" });
  const [addSetSelected, setAddSetSelected] = useState<any>({ label: "Select", value: "Select" });
  const [campaignSetSelected, setCampaignSelected] = useState<any>({ label: "Select", value: "Select" });
  const [ownerSelected, setOwnerSelected] = useState<any>({ label: "Select", value: "Select" });
  const [usersList, setUsersList] = useState<any>([]);
  const [projectsList, setProjectsList] = useState<any[]>([]);
  const [locationsList, setLocationsList] = useState<any[]>([]);
  const [budgetsList, setBudgetsList] = useState<any[]>([]);
  const [propertyTypeList, setPropertyTypeList] = useState<any[]>([]);
  const [allPropertySubTypeList, setAllPropertySubTypeList] = useState<any[]>([]);
  const [propertyTypeOldList, setPropertyTypeOldList] = useState<any[]>([]);
  const [propertyStageList, setPropertyStageList] = useState<any[]>([]);
  const [leadTypeList, setleadTypeList] = useState<any[]>([]);
  const [nextFollowUpList, setnextFollowUpList] = useState<any[]>([]);
  const [notIntReasonList, setNotIntReasonList] = useState<any[]>([]);
  const [lostReasonList, setLostReasonList] = useState<any[]>([]);
  const [comTypes, setComTypes] = useState<any[]>([]);
  const [resTypes, setResTypes] = useState<any[]>([]);
  const [propertySubType, setPropertySubType] = useState<any[]>([]);
  const [leadSourceList, setLeadSourceList] = useState<any[]>([]);
  const [uidList, setUidList] = useState<any>();
  const [addSet, setAddSet] = useState<any[]>([]);
  const [leadSource, setLeadSource] = useState<any[]>([]);
  const [campaign, setCampaign] = useState<any[]>([]);
  const fieldOneRef: any = useRef();
  const fieldTwoRef: any = useRef();
  const fieldThreeRef: any = useRef();
  const fieldFourRef: any = useRef();
  const fieldFiveRef: any = useRef();
  const fieldSixRef: any = useRef();
  const [maxHeight, setMaxHeight] = useState(window.innerHeight * 0.8);

  const handleResize = () => {
    setMaxHeight(window.innerHeight * 0.8);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    if (authToken) {
      getLeadsFilterValues();
    }
  }, [authToken]);

  const getLeadsFilterValues = async () => {
    axios.defaults.headers.common['x-access-token'] = authToken
    const res = await axios.post(url + '/leads/filterValues', {
      uid: user.uid,
    });
    setAddSet(res.data[0]?.addset);
    setCampaign(res.data[0]?.campaign);
  }

  useEffect(() => {
    window.onbeforeunload = function () {
      return "Are you really want to perform the action?";
    };
    if (role === "Lead Manager" && organizationUsers) {
      let uids: { [key: string]: string } = {};
      let data: any = [];
      organizationUsers.map((item: any) => {
        data.push(
          `${item.user_first_name} ${item.user_last_name}-${item.user_email}`
        );
        uids[item.user_email] = item.uid;
      });
      const usersListFormatted = Array.isArray(data)
        ? data.map((item: any) =>
          typeof item === "string"
            ? { label: item, value: item }
            : item
        )
        : []
      setUsersList(usersListFormatted);
      setUidList(uids);
    }
  }, []);

  useEffect(() => {
    const unsub = contactResources(
      user.organization_id,
      (data) => setLocationsList(
        Array.isArray(data)
          ? data.map((item: any) =>
            typeof item === "string"
              ? { label: item, value: item }
              : item
          )
          : []
      ),
      (data) => setBudgetsList(
        Array.isArray(data)
          ? data.map((item: any) =>
            typeof item === "string"
              ? { label: item, value: item }
              : item
          )
          : []
      ),
      (data) => setProjectsList(
        Array.isArray(data)
          ? data.map((item: any) =>
            typeof item === "string"
              ? { label: item, value: item }
              : item
          )
          : []
      ),
    );
    const unsubConst = fetchConstants(
      (data) => setNotIntReasonList(
        Array.isArray(data)
          ? data.map((item: any) =>
            typeof item === "string"
              ? { label: item, value: item }
              : item
          )
          : []
      ),
      (data) => setLostReasonList(
        Array.isArray(data)
          ? data.map((item: any) =>
            typeof item === "string"
              ? { label: item, value: item }
              : item
          )
          : []
      ),
      (data) => setPropertyStageList(
        Array.isArray(data)
          ? data.map((item: any) =>
            typeof item === "string"
              ? { label: item, value: item }
              : item
          )
          : []
      ),
      (data) => setPropertyTypeOldList(
        Array.isArray(data)
          ? data.map((item: any) =>
            typeof item === "string"
              ? { label: item, value: item }
              : item
          )
          : []
      ),
      (data) => setnextFollowUpList(
        Array.isArray(data)
          ? data.map((item: any) =>
            typeof item === "string"
              ? { label: item, value: item }
              : item
          )
          : []
      )
    );
    const unNewPropertyType = fetchpropertyType(
      user.organization_id,
      (data) => setPropertyTypeList(
        Array.isArray(data)
          ? data.map((item: any) =>
            typeof item === "string"
              ? { label: item, value: item }
              : item
          )
          : []
      )
    );
    const unNewPropertySubType = fetchNewPropertySubType(
      user.organization_id,
      (data) => setAllPropertySubTypeList(
        Array.isArray(data)
          ? data.map((item: any) =>
            typeof item === "string"
              ? { label: item, value: item }
              : item
          )
          : []
      )
    );
    let data = [
      { label: "Data", value: "Data" },
      { label: "Leads", value: "Leads" }
    ];
    setleadTypeList(data);
    const unsubProperty = fetchpropertySubType(
      user.organization_id,
      (data) => setComTypes(data),
      (data) => setResTypes(data),
      (data) => setLeadSourceList(
        Array.isArray(data)
          ? data.map((item: any) =>
            typeof item === "string"
              ? { label: item, value: item }
              : item
          )
          : []
      )
    );
    return () => {
      unsub();
      unsubConst();
      unsubProperty();
      unNewPropertyType();
      unNewPropertySubType();
    };
  }, []);

  useEffect(() => {
    const filteredArray = allPropertySubTypeList.filter(item => item.property_type === propertyTypeSelected.value);
    const propertySubTypes = filteredArray.map(item => item.property_sub_type);
    if (propertySubTypes.length !== 0) {
      setPropertySubType(
        Array.isArray(propertySubTypes)
          ? propertySubTypes.map((item: any) =>
            typeof item === "string"
              ? { label: item, value: item }
              : item
          )
          : []
      )
    } else {
      setPropertySubType([]);
    }
  }, [propertyTypeSelected]);

  useEffect(() => {
    let data: any[] = [];
    country_code.forEach((item) => {
      data.push(item.dial_code + " " + item.name);
    });
    setCountryCodeList(data);
  }, []);

  useEffect(() => {
    const code = "+" + phoneCountryCode; // Specify the code you want to find
    const result = countryCodeList.find(item => item.startsWith(code));
    if (result) {
      setCountryCode(result);
    }
  }, [phoneCountryCode]);

  useEffect(() => {
    let selected: string[] = [];
    if (user.country) {
      selected = countryCodeList.filter((item) => item.toLowerCase().includes(user.country.toLowerCase()));
    } else {
      selected = countryCodeList.filter((item) => item.toLowerCase().includes("+91"));
    }
    if (selected.length !== 0) {
      setCountryCode(selected[0]);
    }
  }, [user.country, countryCodeList]);

  const handlePhoneChange = (value: string, country: CountryData) => {
    if (value.startsWith(country?.dialCode)) {
      const phoneNumberWithoutCode = value.substring(country?.dialCode.length);
      setFinalPhoneNumber(phoneNumberWithoutCode);
    } else {
      setFinalPhoneNumber(value);
    }
    setPhoneCountryCode(country?.dialCode);
    setPhoneNumber(value)
  };

  const handleAlternatePhoneChange = (value: string, country: CountryData) => {
    if (value.startsWith(country?.dialCode)) {
      const phoneNumberWithoutCode = value.substring(country?.dialCode.length);
      setFinalAlternatePhoneNumber(phoneNumberWithoutCode);
    } else {
      setFinalAlternatePhoneNumber(value);
    }
    setAlternatePhoneCountryCode(country?.dialCode);
    setAlternatePhoneNumber(value)
  };


  const create = async (e: any) => {
    e.preventDefault();
    const numberExp = /^[0-9]+$/;
    if (user.organization_id) {
      if (firstNameRef.current.value === "") {
        dispatcher(showSnackbarAction("First Name Required!!", "error"));
        return;
      }
      //  else if (lastNameRef.current.value === "") {
      //   dispatcher(showSnackbarAction("Last Name Required!!", "error"));
      //   return;
      // }
       else if (finalPhoneNumber === "") {
        dispatcher(showSnackbarAction("Mobile Number Required!!", "error"));
        return;
      } else if (emaileRef.current.value !== "" && emailValidate(emaileRef.current.value) === "Invalid Email") {
        dispatcher(showSnackbarAction("Invalid Email!!", "error"));
        return;
      } else if (!(leadTypeSelected.value === "Leads" || leadTypeSelected.value === "Data")) {
        dispatcher(showSnackbarAction("Lead Type Required!!", "error"));
        return;
      } else if (countryCode === "") {
        dispatcher(showSnackbarAction("Country Code Required!!", "error"));
        return;
      }
      else if (fieldOneRef.current.value !== "") {
        if (!numberExp.test(fieldOneRef.current.value)) {
          dispatcher(showSnackbarAction(`${conatctHeader.find((obj: any) => obj.label === "field_one").value} contain only number!!`, "error"));
          return;
        }
      }
      else if (fieldTwoRef.current.value !== "") {
        if (!numberExp.test(fieldTwoRef.current.value)) {
          dispatcher(showSnackbarAction(`${conatctHeader.find((obj: any) => obj.label === "field_two").value} contain only number!!`, "error"));
          return;
        }
      }
      setLoad(true);
      let l = ownerSelected.value.split("-");
      let email = l[1];
      const country = country_code.find((el: any) => el.dial_code === countryCode.split(" ")[0]);
      createContacts(
        user.organization_id,
        emaileRef.current.value,
        firstNameRef.current.value,
        lastNameRef.current.value || "",
        finalPhoneNumber,
        user.user_first_name + " " + user.user_last_name,
        role === "Lead Manager" ? uidList[email] !== undefined ? uidList[email] : user.uid : user.uid,
        dispatcher,
        history,
        role === "Lead Manager" ? email !== undefined ? email : user.user_email : user.user_email,
        finalAlternatePhoneNumber,
        countryCode.split(" ")[0],
        (data: boolean) => setLoad(data),
        country ? country.name : "India",
        propertyTypeSelected.value === "Select" ? "" : propertyTypeSelected.value,
        propertyStageSelected.value === "Select" ? "" : propertyStageSelected.value,
        leadTypeSelected.value === "Select" ? "Data" : leadTypeSelected.value,
        locationSelected.value === "Select" ? "" : locationSelected.value,
        budgetSelected.value === "Select" ? "" : budgetSelected.value,
        projectSelected.value === "Select" ? "" : projectSelected.value,
        propertySubTypeSelected.value === "Select" ? "" : propertySubTypeSelected.value,
        leadSourceSelected.value === "Select" ? "Self Generated" : leadSourceSelected.value,
        addSetSelected.value === "Select" ? "" : addSetSelected.value,
        campaignSetSelected.value === "Select" ? "" : campaignSetSelected.value,
        noteRef.current.value,
        false,
        user.user_email,
        organizationData.allowDuplicateLeads,
        fieldOneRef.current.value !== "" ? fieldOneRef.current.value : "",
        fieldTwoRef.current.value !== "" ? fieldTwoRef.current.value : "",
        fieldThreeRef.current.value !== "" ? fieldThreeRef.current.value : "",
        fieldFourRef.current.value !== "" ? fieldFourRef.current.value : "",
        fieldFiveRef.current.value !== "" ? fieldFiveRef.current.value : "",
        fieldSixRef.current.value !== "" ? fieldSixRef.current.value : ""
      );
    }
  };

  const containerStyles = { backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }
  const cardContainerStyles = { backgroundColor: theme ? themeColors.cardBackgroundColor : themeColors.cardBackgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }
  return (
    <Box className={styles.parent} sx={{ ...containerStyles, marginTop: isMobile ? "6%" : "4%", fontFamily: "var(--font-family-main)" }}>
      {load && <Loading />}
      {isMobile && (
        <Box
          className="d-flex flex-row w-100 px-4 pt-4"
        >
          <h5
            style={{ fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-large)" }}
          >
            Add Contacts Details
          </h5>
          <AiOutlineClose
            className={styles.closeIcon}
            size={25}
            onClick={() => history.replace("/")}
          />
        </Box>
      )}
      <Box
        className={`w-100 d-flex flex-column gap-2 ${isMobile ? "px-1" : "px-4"}`}
        style={{
          padding: isMobile ? '0' : '',
          maxWidth: isMobile ? '100vw' : undefined,
          margin: isMobile ? '0' : '0 auto',
          overflowY: 'auto',
          maxHeight: isMobile ? 'calc(100vh - 120px)' : "calc(100vh - 50px)",
        }}
      >
        <form
          className={`card shadow rounded mt-2${!isMobile ? ` ${styles.forcePadding}` : ""}`}
          style={{
            ...cardContainerStyles,
            padding: isMobile ? '16px' : '32px 8px 8px 32px',
            boxSizing: 'border-box',
            minHeight: isMobile ? 'auto' : undefined,
            marginBottom: isMobile ? '50px' : 0,
          }}
        >
          <Grid container spacing={isMobile ? 2 : 3}>
            <Grid item xs={12} sm={4}>
              <TextInput
                title="First Name"
                style={{ backgroundColor: "#fff", width: '100%' }}
                ref={firstNameRef}
                required={true}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextInput
                title="Last Name"
                style={{ backgroundColor: "#fff", width: '100%' }}
                ref={lastNameRef}
                // required={true}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextInput
                title={conatctHeader.find((obj: any) => obj.label === "email").value}
                style={{ backgroundColor: "#fff", width: '100%' }}
                ref={emaileRef}
                validator={emailValidate}
                required={true}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <PhoneNumberWrapper
                title={conatctHeader.find((obj: any) => obj.label === "contact_no").value}
                country={phoneCountryCode || 'in'}
                value={phoneNumber}
                handlePhoneChange={handlePhoneChange}
                required={true}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <PhoneNumberWrapper
                title={conatctHeader.find((obj: any) => obj.label === "alternate_no").value}
                country={alternatePhoneCountryCode || 'in'}
                value={alternatePhoneNumber}
                handlePhoneChange={handleAlternatePhoneChange}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <DropDownText
                title={conatctHeader.find((obj: any) => obj.label === "lead_type").value}
                options={leadTypeList}
                value={leadTypeSelected.value === "Select" ? "" : leadTypeSelected.value}
                onChange={(e: any) => setLeadTypeSelected({ value: e.target.value, label: e.target.value })}
                labelKey="label"
                valueKey="value"
                required={true}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <DropDownText
                title={conatctHeader.find((obj: any) => obj.label === "location").value}
                options={locationsList}
                value={locationSelected.value === "Select" ? "" : locationSelected.value}
                onChange={(e: any) => setlocationSelected({ value: e.target.value, label: e.target.value })}
                labelKey="label"
                valueKey="value"
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <DropDownText
                title={conatctHeader.find((obj: any) => obj.label === "project").value}
                options={projectsList}
                value={projectSelected.value === "Select" ? "" : projectSelected.value}
                onChange={(e: any) => setProjectSelected({ value: e.target.value, label: e.target.value })}
                labelKey="label"
                valueKey="value"
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <DropDownText
                title={conatctHeader.find((obj: any) => obj.label === "property_type").value}
                options={propertyTypeList}
                value={propertyTypeSelected.value === "Select" ? "" : propertyTypeSelected.value}
                onChange={(e: any) => setPropertyTypeSelected({ value: e.target.value, label: e.target.value })}
                labelKey="label"
                valueKey="value"
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <DropDownText
                title={conatctHeader.find((obj: any) => obj.label === "property_stage").value}
                options={propertyStageList}
                value={propertyStageSelected.value === "Select" ? "" : propertyStageSelected.value}
                onChange={(e: any) => setPropertyStageSelected({ value: e.target.value, label: e.target.value })}
                labelKey="label"
                valueKey="value"
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <DropDownText
                title={conatctHeader.find((obj: any) => obj.label === "budget").value}
                options={budgetsList}
                value={budgetSelected.value === "Select" ? "" : budgetSelected.value}
                onChange={(e: any) => setBudgetSelected({ value: e.target.value, label: e.target.value })}
                labelKey="label"
                valueKey="value"
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <DropDownText
                title={conatctHeader.find((obj: any) => obj.label === "property_sub_type").value}
                options={propertySubType}
                value={propertySubTypeSelected.value === "Select" ? "" : propertySubTypeSelected.value}
                onChange={(e: any) => setPropertySubTypeSelected({ value: e.target.value, label: e.target.value })}
                labelKey="label"
                valueKey="value"
              />
            </Grid>
            {user.profile === "Lead Manager" && (
              <>
                <Grid item xs={12} sm={4}>
                  <DropDownText
                    title={conatctHeader.find((obj: any) => obj.label === "lead_source").value}
                    options={leadSourceList}
                    value={leadSourceSelected.value === "Select" ? "" : leadSourceSelected.value}
                    onChange={(e: any) => setLeadSourceSelected({ value: e.target.value, label: e.target.value })}
                    labelKey="label"
                    valueKey="value"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <DropDownText
                    title={conatctHeader.find((obj: any) => obj.label === "contact_owner_email").value}
                    options={usersList}
                    value={ownerSelected.value === "Select" ? "" : ownerSelected.value}
                    onChange={(e: any) => setOwnerSelected({ value: e.target.value, label: e.target.value })}
                    labelKey="label"
                    valueKey="value"
                  />
                </Grid>
              </>
            )}
            {user.profile === "Team Lead" && (
              <Grid item xs={12} sm={4}>
                <DropDownText
                  title={conatctHeader.find((obj: any) => obj.label === "lead_source").value}
                  options={leadSourceList}
                  value={leadSourceSelected.value === "Select" ? "" : leadSourceSelected.value}
                  onChange={(e: any) => setLeadSourceSelected({ value: e.target.value, label: e.target.value })}
                  labelKey="label"
                  valueKey="value"
                />
              </Grid>
            )}
            <Grid item xs={12} sm={4}>
              <TextInput
                title={conatctHeader.find((obj: any) => obj.label === "field_one").value}
                style={{ backgroundColor: "#fff", width: '100%' }}
                ref={fieldOneRef}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextInput
                title={conatctHeader.find((obj: any) => obj.label === "field_two").value}
                style={{ backgroundColor: "#fff", width: '100%' }}
                ref={fieldTwoRef}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextInput
                title={conatctHeader.find((obj: any) => obj.label === "field_three").value}
                style={{ backgroundColor: "#fff", width: '100%' }}
                ref={fieldThreeRef}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextInput
                title={conatctHeader.find((obj: any) => obj.label === "field_four").value}
                style={{ backgroundColor: "#fff", width: '100%' }}
                ref={fieldFourRef}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextInput
                title={conatctHeader.find((obj: any) => obj.label === "field_five").value}
                style={{ backgroundColor: "#fff", width: '100%' }}
                ref={fieldFiveRef}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextInput
                title={conatctHeader.find((obj: any) => obj.label === "field_six").value}
                style={{ backgroundColor: "#fff", width: '100%' }}
                ref={fieldSixRef}
              />
            </Grid>
            {user.profile === "Lead Manager" && (
              <>
                <Grid item xs={12} sm={4}>
                  <DropDownText
                    title={conatctHeader.find((obj: any) => obj.label === "addset").value}
                    options={addSet}
                    value={addSetSelected.value === "Select" ? "" : addSetSelected.value}
                    onChange={(e: any) => setAddSetSelected({ value: e.target.value, label: e.target.value })}
                    labelKey="label"
                    valueKey="value"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <DropDownText
                    title={conatctHeader.find((obj: any) => obj.label === "campaign").value}
                    options={campaign}
                    value={campaignSetSelected.value === "Select" ? "" : campaignSetSelected.value}
                    onChange={(e: any) => setCampaignSelected({ value: e.target.value, label: e.target.value })}
                    labelKey="label"
                    valueKey="value"
                  />
                </Grid>
              </>
            )}
            <Grid item xs={12} sm={8}>
              <CustomTextArea
                fullWidth
                label="Add Note"
                inputRef={noteRef}
                variant="outlined"
                multiline
                rows={1}
                onChange={(e) => setNote(e.target.value)}
                value={note}
                InputLabelProps={{ style: { color: "#555", fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-medium)" } }}
                InputProps={{ style: { color: '#222', fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-medium)" } }}
              />
            </Grid>
            {/* Remove submit button from inside form for mobile */}
            {!isMobile && (
              <Grid item xs={12} style={{ marginTop: 12 }}>
                <StyledSubmitButton
                  onClick={(e) => create(e)}
                  themeMode={themeMUI.palette.mode}
                >
                  {load ? (
                    <span style={{ display: "flex", justifyContent: "center" }}>
                      <Circles color="#fff" height={20} width={20} />
                    </span>
                  ) : (
                    <>Submit</>
                  )}
                </StyledSubmitButton>
              </Grid>
            )}
          </Grid>
        </form>
      </Box>
      {isMobile && (
        <Box
          sx={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            bgcolor: "white",
            p: 2,
            borderTop: "1px solid #ddd",
            boxShadow: "0 -2px 6px rgba(0,0,0,0.1)",
            zIndex: 100,
          }}
        >
          <StyledSubmitButton
            onClick={(e) => create(e)}
            themeMode={themeMUI.palette.mode}
            isMobile={isMobile}
          >
            {load ? (
              <span style={{ display: "flex", justifyContent: "center" }}>
                <Circles color="#fff" height={20} width={20} />
              </span>
            ) : (
              <>Submit</>
            )}
          </StyledSubmitButton>
        </Box>
      )}
    </Box>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    organizationUsers: state.organizationUsers.data,
    role: state.user.role,
    theme: state.theme.isLightMode,
    conatctHeader: state.contactHeaderList.data,
    authToken: state.user.authToken,
    organizationData: state.organization.organizationData,
  };
};

export default connect(mapStateToProps)(AddContacts);
